import { Subject, delay } from 'rxjs';

export class ActiveDialog<Data> {
  readonly #result = new Subject<Data | undefined>();
  readonly result = this.#result.pipe(delay(1));
  #titleElement: HTMLElement | null = null;

  constructor(readonly nativeElement: HTMLDialogElement) {}

  close(payload?: Data) {
    this.#result.next(payload);
    this.#result.complete();
    this.nativeElement.close();
  }

  setTitleElement(element: HTMLElement | null): void {
    this.#titleElement = element;
  }

  updateTitle(title: string): void {
    if (this.#titleElement) {
      this.#titleElement.textContent = title;
    }
  }
}
